module.exports = __webpack_public_path__ + "img/a10.97bd210a.jpg";